export const AUTOFILL_ANIMATION_NAME = 'onAutoFillStart'
export const EMAIL_BLACKLIST = [
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'hotmail.de',
  'hotmail.pl',
  'hotmail.com.au',
  'icloud.com',
  'live.com',
  'live.com.au',
  'live.co.uk',
  'live.fr',
  'live.de',
  'live.it',
  'live.ca',
  'aol.com',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.fr',
  'yahoo.it',
  'yahoo.de',
  'yahoo.com.au',
  'ymail.com',
  'ymail.fr',
  'ymail.co.uk'
]
